// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/lib/components/content-documents/media-document/ingress/ingress.component.scss
// module id = 156
// module chunks = 0